export default {
  delivered: {
    'link-feedback-popup': {
      title: 'Спасибо, что воспользовались нашим сервисом. Мы ценим ваш отзыв.',
      subtitle: 'Пожалуйста, оставьте отзыв на нашей странице в Google',
      btn: 'Ок',
    },
    info: {
      'payment-delivered-title': 'Доставлено',
    },
    feedback: {
      title: 'Ваше мнение важно для нас',
      comment: {
        title: 'Пожалуйста, оставьте ваш комментарий:',
        placeholder: 'Напишите, понравилось ли вам всё, ваши ожидания и впечатления',
        'send-btn': 'Отправить отзыв',
        'change-btn': 'Изменить отзыв',
        'not-send-tooltip': {
          text: 'Свяжитесь со мной',
          title: 'С вами свяжется служба поддержки',
          content: 'Пожалуйста, оставьте отзыв, и наш агент службы поддержки свяжется с вами в ближайшее время.',
        },
      },
      suggestions: {
        driver: {
          positive: {
            'went-above-and-beyond': 'Превзошёл ожидания',
            'professional-appearance': 'Профессиональный внешний вид',
            'courteous-and-respectful': 'Вежливый и уважительный',
            'on-time-delivery': 'Доставка вовремя',
          },
          negative: {
            'unfriendly-driver': 'Неприветливый водитель',
            'did-not-follow-instructions': 'Не выполнил инструкции',
            'late-delivery': 'Поздняя доставка',
            'unprofessional-appearance': 'Непрофессиональный внешний вид',
          },
        },
        dispatcher: {
          positive: {
            'great-communication': 'Отличная коммуникация',
            'patient-and-understanding': 'Терпеливый и понимающий',
            'efficient-coordination': 'Эффективная координация',
            'quick-response-time': 'Быстрая реакция',
          },
          negative: {
            'impatient-or-rude': 'Нетерпеливый или грубый',
            'poor-coordination': 'Плохая координация',
            'failed-to-address-concerns': 'Не решил проблемы',
            'slow-response-time': 'Медленная реакция',
          },
        },
        pharmacy: {
          positive: {
            'friendly-staff': 'Дружелюбный персонал',
            'secure-packaging': 'Надёжная упаковка',
            'fast-shipping': 'Быстрая доставка/повторные заказы',
            'concise-medication-instructions': 'Краткие инструкции по лекарствам',
          },
          negative: {
            'difficult-to-open': 'Сложно открыть',
            'incorrect-prescription': 'Неверный рецепт',
            'unfriendly-staff': 'Негостеприимный персонал',
            'wrong-medication': 'Неправильное лекарство',
          },
        },
      },
    },
  },
  delivering: {
    confirmed: {
      'stops-away': 'остановок до прибытия',
      'your-stop-is-next': 'Ваша остановка следующая',
      'special-instruction': {
        title: 'Особая инструкция аптеки:',
        'new-instruction-input': {
          title: 'Особые инструкции получателя',
          placeholder: 'Добавьте особую инструкцию',
        },
        'new-instruction-btn-save': 'Сохранить',
        'not-editable-warning': 'Извините, изменить инструкцию нельзя, так как водитель уже рядом.',
      },
      'arriving-data': {
        today: {
          'label-2': 'Прибудет сегодня',
          label: 'Ориентировочное время доставки',
        },
        next: {
          label: 'Водитель прибудет через',
          time: 'Несколько минут',
        },
        'few-minutes': {
          'label-2': 'Водитель прибудет через',
        },
      },
      qr: {
        info: 'Покажите QR-код водителю',
        description: 'Для получения заказа покажите QR-код водителю или сообщите код',
        help: 'Кооплата — это фиксированная сумма, которую вы обязаны оплатить за медицинские услуги или рецепты в рамках вашей страховой программы.',
      },
    },
    'confirmed-no-route': {
      title: 'Вы подтвердили доставку',
      subtitle: 'Ожидайте информацию',
      'for-date': 'на {date}',
    },
    'not-confirmed': {
      form: {
        'empty-title': 'Пожалуйста, оставьте подпись',
        'pharmacy-instruction-title': 'Особая инструкция аптеки:',
        'recipient-instruction': {
          title: 'Особые инструкции получателя:',
          placeholder: 'Добавьте особую инструкцию',
          'update-btn': 'Обновить',
        },
        sign: {
          description: 'Водитель попытается доставить лично. Если никого нет дома, оставит посылку у двери и сделает фото.',
          confirm: {
            btn: 'Подтвердить доставку',
            title: 'Вы уверены?',
            text: 'Я подтверждаю, что предоставленная информация верна и точна',
          },
        },
      },
      progress: {
        attempts: 'Попытка доставки:',
        created: 'Заказ <br> создан',
      },
      transit: 'В пути',
      'out-for-delivery': 'В пути <br> на доставке',
      delivered: 'Доставлено',
      signature: {
        title: 'Подпишите ниже, чтобы разрешить оставить посылку без подписи:',
        clear: 'Очистить',
      },
      statuses: {
        'at-pharmacy': 'Ваш заказ в аптеке и будет доставлен',
        'driver-out': 'Подтвердите доставку',
        rescheduled: 'Доставка перенесена на',
        'pending-back-to-pharmacy': 'Ваш заказ ожидает возврата в аптеку',
        'pickup-occured': 'Ваш заказ забрали из аптеки и доставят',
      },
    },
    rescheduled: {
      attempted: 'Попытка доставки была',
    },
  },
  investigation: {
    link_start: 'Пожалуйста, свяжитесь с нами по телефону',
    link_end: 'для согласования доставки',
    instructions: 'Особая инструкция аптеки:',
  },
  rescadule: {
    subtitle: 'Пожалуйста, выберите новую дату доставки',
    'too-many': 'Заказ нельзя перенести больше 3 раз. Позвоните по номеру {phone}',
    'wrong-address': 'Водителю не удалось найти ваш адрес. Укажите правильный адрес.',
    'not-present': 'Водитель был по вашему адресу, но никто не открыл дверь.',
  },
  rejected: {
    'back-to-pharmacy': {
      rejected: 'Заказ отменён аптекой',
      'pending-back-to-pharmacy': 'Ваш заказ отменён и ожидает возврата в аптеку',
      'on-its-way-to-pharmacy': 'Ваш заказ отменён и подтверждён возврат в аптеку',
      default: 'Ваш заказ отменён и отправлен обратно в аптеку',
      'confirmed-back-to-pharmacy': 'Заказ отменён, ожидается подтверждение возврата аптекой',
      'back-to-pharmacy': 'Заказ отменён и отправлен обратно в аптеку',
    },
  },
  returned: {
    'back-to-pharmacy': {
      title: 'Ваш заказ ожидает возврата в аптеку',
    },
  },
}
